import { useEffect } from 'react';
import { useParams, useNavigate, Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export const SUPPORTED_LANGS = ['fr', 'en', 'ar', 'es'];
export const DEFAULT_LANG = 'fr';

// Wraps the public/marketing routes mounted under /:lang — keeps i18n's active
// language in sync with the URL segment (source of truth for these pages,
// unlike the rest of the app which relies on localStorage/browser detection)
// and bounces unsupported language codes back to the default.
const LangLayout = () => {
  const { lang } = useParams();
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const isSupported = SUPPORTED_LANGS.includes(lang);

  useEffect(() => {
    if (isSupported && i18n.language !== lang) {
      i18n.changeLanguage(lang);
    } else if (!isSupported) {
      navigate(`/${DEFAULT_LANG}`, { replace: true });
    }
  }, [lang, isSupported, i18n, navigate]);

  if (!isSupported) return null;

  return <Outlet />;
};

export default LangLayout;
